import { render, staticRenderFns } from "./loykathong.vue?vue&type=template&id=eb60c1ca&scoped=true"
import script from "./loykathong.vue?vue&type=script&lang=js"
export * from "./loykathong.vue?vue&type=script&lang=js"
import style0 from "./loykathong.vue?vue&type=style&index=0&id=eb60c1ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb60c1ca",
  null
  
)

export default component.exports